
import { Component, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../../../../../../base/domain/drawing";
import { RectangleCoordinateEditableMixin } from "../mixins";
import { default as ObjectDrawerBase } from "./ObjectDrawerBase.vue";

@Component
export default class RectangleCoordinatableObjectDrawerBase extends Mixins(ObjectDrawerBase, RectangleCoordinateEditableMixin) {
  get absoluteGeometryStyleProperties() {
    return {
      left: this.offsetRectangleCoordinate.topLeft.x + "px",
      top: this.offsetRectangleCoordinate.topLeft.y + "px",
      width: this.offsetRectangleCoordinate.size.width + "px",
      height: this.offsetRectangleCoordinate.size.height + "px",
    };
  }

  get relativeGeometryStyleProperties() {
    return {
      left: "0px",
      top: "0px",
      width: this.offsetRectangleCoordinate.size.width + "px",
      height: this.offsetRectangleCoordinate.size.height + "px",
    };
  }

  get relativeRectangle(): Rectangle {
    return this.offsetRectangleCoordinate.moveTo(new Point(0, 0));
  }

  get offsetRectangleCoordinate(): Rectangle {
    if (!this.isSelected) {
      return this.rectangleCoordinate;
    }
    const rates = this.offsets.transformingRatesFromCenter;
    const center = this.rectangleCoordinate.center;
    const topLeftOffset = this.rectangleCoordinate.topLeft.subtract(center);
    const size = this.rectangleCoordinate.size;
    return new Rectangle(
      center.add(new Point(topLeftOffset.x * rates.x, topLeftOffset.y * rates.y)).add(this.offsets.relocatingOffset),
      new Size(size.width * rates.width, size.height * rates.height)
    );
  }

  get configuredStyle() {
    return this.configuration
      ? {
        color: this.configuration.foregroundColorCode,
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: this.configuration.borderColorCode,
        backgroundColor: this.configuration.backgroundColorCode,
        boxSizing: "border-box",
      }
      : {};
  }
}
